var React = require('react');

function ArrowTopRightGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.50962 1.29388L0.445906 1.29388L0.445906 0L9.64345 0L9.64345 9.54234H8.39633L8.39633 2.20375L0.88185 9.99992L0 9.08501L7.50962 1.29388Z","fill":"#A2A2A2"}));
}

ArrowTopRightGrey.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = ArrowTopRightGrey;

ArrowTopRightGrey.default = ArrowTopRightGrey;
